import styled from "styled-components";

export const H2 = styled.h2`
    color: inherit;
    font-size: 30px;
    font-weight: bold;
`;
